import { render, staticRenderFns } from "./PreviewSinglechoiceModule.vue?vue&type=template&id=7a9cac30&scoped=true&"
import script from "./PreviewSinglechoiceModule.vue?vue&type=script&lang=js&"
export * from "./PreviewSinglechoiceModule.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSinglechoiceModule.vue?vue&type=style&index=0&id=7a9cac30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9cac30",
  null
  
)

export default component.exports